import styled from 'styled-components';

export const ContainerMaintenance = styled.div<{ backImage: string }>`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3vw;
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.backImage});
`;

export const TextTitle = styled.h1`
  font-family: 'Libre Franklin', sans-serif;
  font-size: 6vw;
  width: 89vw;
  text-align: center;
  color: #ffffff;
  margin-top: 55vh;
`;
